import { GeneralAction, GeneralActionType } from "../actions/generalAction";
import { General } from "../states/general";
import { Lang } from "../states/query";

const genetalInitial: General = {
  /** 経路取得に失敗したことを表すフラグ。 */
  isFailInGetCourses: false,
  /** GoogleMapを表示するかを判定するフラグ */
  isShowMap: false,
  /** FindCandidateListModalで経由地を選択しているかを判定するフラグ */
  candidateSelectorIsVia: false,
  /** 目的地・出発地を選択するモーダルを表示するかを判定するフラグ */
  isShowCandidateListModal: false,
  /** 地図画面でから目的地・出発地を選択するモーダルにもだった状態であるかを判定するフラグ */
  isFromMapToCandidateListModal: false,
  /** 遷移元のリファラーURL */
  referrer: '',
  /** 初期描画であるかを表すフラグ。 */
  isInitial: true,
  isLoading: false,
  axiosError: null,
  errorMessage: '',
  traininfoList: {},
  lang: Lang.ja,
  isFailInAssignDia: false,
  isBackendCrowded: {
    search: false,
    getFlightInfo: false,
    searchDiaList: false
  },
  tmp: {
    placeInfo: {
      pointName: '',
      pointCode: '',
      pointType: '',
      place: null,
      lastSelectedPlace: null,
      pointGeoCode: {
        lat: 0,
        lng: 0
      },
      isUpdateInMapSelector: false
    },
    updateCheck: 0,
    isShowPublicSummary: false,
    applyConvertingToMultipleAirport: {
      outbound: false,
      returnTrip: false
    },
    publicInterruptTransferStations: {
      isResearch: false,
      isOutbound: false
    },
    debugErrorMessage: '',
    adRotationRand: 0
  },
  universalMaaSQuery: {},
  mode: {
    isShowBarrierFreeInfo: false,
    isBarrierFreeMode: false
  },
  interruptTransfer: {
    outbound: {
      interruptTransferStations: [],
      interruptTransferStationsInUndecided: []
    },
    returnTrip: {
      interruptTransferStations: [],
      interruptTransferStationsInUndecided: []
    }
  },
  /** タクシー仮予約ページでreCAPTHCA v2を利用するかを表すフラグ。 */
  useV2: false,
}

const generalReducer = (state = genetalInitial, action: GeneralAction) => {
  const newInterruptTransfer = state.interruptTransfer;
  switch(action.type) {
    case GeneralActionType.SWITCH_IS_FAIL_IN_GET_COURSES:
      return {
        ...state,
        isFailInGetCourses: action.payload,
      };
    case GeneralActionType.SWITCH_SHOW_MAP:
      return {
        ...state,
        isShowMap: action.payload,
      }
    case GeneralActionType.SWITCH_CANDIDATE_SELECTOR_IS_VIA:
    return {
      ...state,
      candidateSelectorIsVia: action.payload,
    }
    case GeneralActionType.SWITCH_SHOW_CANDIDATE_LIST_MODAL:
      return {
        ...state,
        isShowCandidateListModal: action.payload,
      }
    case GeneralActionType.SWITCH_IS_FROM_MAP_TO_CANDIDATE_LIST_MODAL:
    return {
      ...state,
      isFromMapToCandidateListModal: action.payload,
    }
    case GeneralActionType.SWITCH_IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      }
    case GeneralActionType.SWITCH_IS_INITIAL:
      return {
        ...state,
        isInitial: action.payload,
      }
    case GeneralActionType.SWITCH_IS_FAIL_ASSIGN_DIA:
      return {
        ...state,
        isFailInAssignDia: action.payload,
      }
    case GeneralActionType.SWITCH_IS_BACKEND_CROWDED_SEARCH:
      return {
        ...state,
        isBackendCrowded: {
          ...state.isBackendCrowded,
          search: action.payload
        },
      }
    case GeneralActionType.SWITCH_IS_BACKEND_CROWDED_GET_FLIGHT_INFO:
      return {
        ...state,
        isBackendCrowded: {
          ...state.isBackendCrowded,
          getFlightInfo: action.payload
        },
      }
    case GeneralActionType.SWITCH_IS_BACKEND_CROWDED_SEARCH_DIA_LIST:
      return {
        ...state,
        isBackendCrowded: {
          ...state.isBackendCrowded,
          searchDiaList: action.payload
        },
      }
    case GeneralActionType.SWITCH_USE_V2:
      return {
        ...state,
        useV2: action.payload,
      }
    case GeneralActionType.UPDATE_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.payload,
      }
    case GeneralActionType.UPDATE_REFERRER:
      return {
        ...state,
        referrer: action.payload,
      };
    case GeneralActionType.UPDATE_TRAININFO:
      return {
        ...state,
        traininfoList: action.payload,
      }
    case GeneralActionType.UPDATE_AXIOS_ERROR:
      return {
        ...state,
        axiosError: action.payload,
      }
    case GeneralActionType.UPDATE_PUBLIC_LANG:
      return {
        ...state,
        lang: action.payload,
      }
    case GeneralActionType.UPDATE_TMP_VALUES:
      return {
        ...state,
        tmp: action.payload,
      }
    case GeneralActionType.UPDATE_UNIVERSAL_MAAS_QUERY:
      return {
        ...state,
        universalMaaSQuery: action.payload,
      };
    case GeneralActionType.UPDATE_TMP_IS_UPDATE_IN_MAP_SELECTOR:
      return {
        ...state,
        tmp: {
          ...state.tmp,
          placeInfo: {
            ...state.tmp.placeInfo,
            isUpdateInMapSelector: action.payload
          }
        }
      }
    case GeneralActionType.RANDOM_TMP_AD_ROATATION_VALUE:
      return {
        ...state,
        tmp: {
          ...state.tmp,
          adRotationRand: action.payload
        }
      }
    case GeneralActionType.UPDATE_TAXI_COMPANY_CONFIGURATIONS:
      return {
        ...state,
        taxiCompanyConfigurations: action.payload,
      }
    case GeneralActionType.UPDATE_TAXI_STAND_INFO:
      return {
        ...state,
        taxiStandInfo: action.payload,
      }
    case GeneralActionType.SWITCH_MODE:
      const newMode = state.mode;
      switch(action.modeType) {
        case 'isShowBarrierFreeInfo':
          newMode.isShowBarrierFreeInfo = action.payload;
          break;
        case 'isBarrierFreeMode':
          newMode.isBarrierFreeMode = action.payload;
          break;
      }
      return {
        ...state,
        mode: newMode,
      };
    case GeneralActionType.UPDATE_INTERRUPT_TRANSFER_STATIONS:
      if(action.isOutbound) {
        newInterruptTransfer.outbound.interruptTransferStations = action.payload;
      }
      else {
        newInterruptTransfer.returnTrip.interruptTransferStations = action.payload;
      }
      return {
        ...state,
        interruptTransfer: newInterruptTransfer,
      }
    case GeneralActionType.UPDATE_INTERRUPT_TRANSFER_STATIONS_IN_UNDECIDED:
      if(action.isOutbound) {
        newInterruptTransfer.outbound.interruptTransferStationsInUndecided = action.payload;
      }
      else {
        newInterruptTransfer.returnTrip.interruptTransferStationsInUndecided = action.payload;
      }
      return {
        ...state,
        interruptTransfer: newInterruptTransfer,
      }
    default:
      return state;
  }
}

export default generalReducer;
